import { useLanguageContext } from "@/hooks";
import React, { useRef, useState } from "react";
import { Button } from "../../../Common";

export default function OtpForm({ otpLength = 4, onResendOtp, onSubmitOtp }) {
    const { language } = useLanguageContext();
    const [otpInputs, setOtpInputs] = useState(Array(otpLength).fill(''));
    const otpInputRefs = useRef(Array.from({ length: otpLength }, () => React.createRef()));

    const handleInputChange = (e, index) => {
        const { value } = e.target;
        const newOtpInputs = [...otpInputs];
        newOtpInputs[index] = value;
        setOtpInputs(newOtpInputs);

        if (/^\d$/.test(value) && index < otpInputs.length - 1) {
            otpInputRefs.current[index + 1].current.focus();
        }
    };

    const handleOtpInputKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otpInputs[index] && index > 0) {
            e.preventDefault();
            otpInputRefs?.current[index - 1].current.focus();
        }
    };

    const handleResentOTP = (e) => {
        setOtpInputs(Array(otpLength).fill(''));
        onResendOtp(e);
    }

    const handleSubmitOTP = (e) => {
        e.preventDefault();
        onSubmitOtp(e, otpInputs.join(''));
    }

    return (
        <div>
            <form onSubmit={handleSubmitOTP}>
                <div className="d-flex flex-row justify-content-center gap-3 my-4">
                    {otpInputs?.map((value, index) => (
                        <input
                            key={index}
                            type="text"
                            className="text-center form-control rounded"
                            maxLength="1"
                            style={{ width: "3rem" }}
                            value={value}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleOtpInputKeyDown(e, index)}
                            ref={otpInputRefs.current[index]} />
                    ))}
                </div>
                <div className="text-center">
                    <Button primary solid rounded type="submit">{language("verify_otp")}</Button>
                </div>
                <div className="mt-3">
                    <span className="mr-2">{language("label.did_nt_receive_code")}</span>
                    <Button noSpacing className="link link-animate-ul" onClick={(e) => handleResentOTP(e)}>{language("label.resend_now")}</Button>
                </div>
            </form>
        </div>
    );
}